import React from 'react'
import HeroSectionListTable from './Componates/HeroSectionListTable'
import AddItemBtn from 'Common/Custom/AddItemBtn';
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import AmenityListTable from "../../Amenity/AmenityList/Components/AmenityListTable"

const HeroSectionList = () => {
  return (
    <>

      <PageBody
        card={true}
        headerchildren={
          <>
            <HeadingOne>Hero Section List</HeadingOne>
            <AddItemBtn url="add-hero-section" title="Add Hero Section" />
          </>
        }>

        {/* Table section */}
        <div className="col-12">
          <HeroSectionListTable />
        </div>

      </PageBody>
      <PageBody
        card={true}
        headerchildren={
          <>
            <HeadingOne>Amenity List</HeadingOne>
            <AddItemBtn url="amenity-add" title="Create Amenity" />
          </>
        }>

        {/* Table section */}
        <div className="col-12">
          <AmenityListTable />
        </div>
      </PageBody>
    </>
  );
};

export default HeroSectionList;
